import { useContext } from 'react';
import { useMentorsContext } from '../../contexts/mentors-context';
import { UserContext } from '../../contexts/user-context';
import { ModalV2 } from '../common';
import AssignMentorsForm from '../forms/assign-mentors';

function MentorAssignModal() {
  const { hasAccessToAction } = useContext(UserContext);
  const {
    assignTargetMentor,
    isAssigningMentor,
    loadedVenturesById,
    handleVenturesLoaded,
    handleAssingSuccessForm,
    setAssignTargetMentor,
  } = useMentorsContext();

  const handleClose = () => {
    setAssignTargetMentor(null);
  };

  return hasAccessToAction('mentor.details.update') && !!assignTargetMentor ? (
    <ModalV2
      open={true}
      onClose={handleClose}
      titleProps={{
        title: 'New assignment',
        caption: `${assignTargetMentor.firstName} ${assignTargetMentor.lastName}`,
      }}
      width='720px'>
      <AssignMentorsForm
        mentorId={assignTargetMentor.id}
        loading={isAssigningMentor[assignTargetMentor.id]}
        onLoaded={handleVenturesLoaded(assignTargetMentor.id)}
        ventures={loadedVenturesById[assignTargetMentor.id]}
        onSuccess={handleAssingSuccessForm(assignTargetMentor.id, handleClose)}
        onCancel={handleClose}
      />
    </ModalV2>
  ) : null;
}

export default MentorAssignModal;
